import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/shared/components';
import type { CalendarDayCell, ChannexChannelResource, PropertyResponse } from '@/shared/api';
import { PropertyCard } from './PropertyCard';
import { PropertyTableRow } from './PropertyTableRow';

interface Props {
  properties: PropertyResponse[];
  cellsByProperty: Map<string, CalendarDayCell[]>;
  stripFrom: string;
  channels: ChannexChannelResource[];
  listContext: Record<string, unknown>;
}

/**
 * Die Apartmentliste: ab genug Breite eine Datentabelle, darunter gestapelte Karten.
 *
 * <p>Die Umschaltung hängt an einer Container-Query und nicht am Fenster — dieselbe Antwort, die
 * Block D für die System-Tabellen und Block E für die Benutzerliste gefunden hat. Der
 * Belegungsstreifen allein misst 138 px; mit Cover, Adresse, Zustand und Kanälen braucht die
 * Zeile deutlich mehr als ein Telefon hergibt.</p>
 */
export function PropertyList({
  properties,
  cellsByProperty,
  stripFrom,
  channels,
  listContext,
}: Props) {
  return (
    <div className="@container">
      <div className="@3xl:block hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Apartment</TableHead>
              <TableHead>Stadt</TableHead>
              <TableHead>Belegung · 14 Tage</TableHead>
              <TableHead className="text-right">Reinigungsgebühr</TableHead>
              <TableHead>Zustand</TableHead>
              <TableHead>Kanäle</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {properties.map((p) => (
              <PropertyTableRow
                key={p.id}
                property={p}
                occupancyCells={cellsByProperty.get(p.id)}
                stripFrom={stripFrom}
                channels={channels}
                listContext={listContext}
              />
            ))}
          </TableBody>
        </Table>
      </div>

      <ul className="@3xl:hidden grid gap-3">
        {properties.map((p) => (
          <PropertyCard
            key={p.id}
            property={p}
            occupancyCells={cellsByProperty.get(p.id)}
            stripFrom={stripFrom}
            channels={channels}
            listContext={listContext}
          />
        ))}
      </ul>
    </div>
  );
}
